import { Component, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { session } from '../../../../environments/environment.session';
import { DashboardService } from '../../service/dashboard.service';
import { SpinnerService } from '../../../shared/spinner.service';
import { ComplaintsService } from '../../service/complaints.service';
import Swal from 'sweetalert2';
import { PdfGeneratorService } from '../../service/pdf-generator.service';
import { ExcelService } from '../../service/file-export.service';
import { TranslationService } from '../../service/translation.service';

@Component({
  selector: 'app-closed-complaints',
  templateUrl: './closed-complaints.component.html',
  styleUrls: ['./closed-complaints.component.css']
})
export class ClosedComplaintsComponent {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  displayedColumns: string[] = ['id', 'ticket_id', 'department', 'zone', 'fullName', 'mobileNo', 'dateTime', 'days_open', 'status', 'action'];

  allComplaints: any[] = [];
  complaints = new MatTableDataSource<any>([]);
  searchText: string = '';
  selectedZone: string | null = null;
  selectedDept: string | null = null;
  uniqueZones: string[] = [];
  uniqueDepartments: string[] = [];
  fromDate: string | null = null;
  toDate: string | null = null;

  constructor(private pdfService: PdfGeneratorService, private router: Router, private dashboardService: DashboardService, private tspinner: SpinnerService, private cs: ComplaintsService, private excelService: ExcelService, public translation: TranslationService) { }
  erpUser: any;
  resolved_count: number = 0;
  department = {};

  async ngOnInit() {
    this.erpUser = JSON.parse(atob(session.erpUser));
    this.getComplaints();
  }

  onDownloadPDF(element: any) {
    const b_acct_id = this.erpUser.b_acct_id;
    this.pdfService.generateComplaintPDF(b_acct_id, element.com_id);
  }

  async getComplaints() {
    let obj = { b_acct_id: this.erpUser.b_acct_id, user_id: this.erpUser.le_id, life_cycle_status: 'CLOSED' };
    this.tspinner.show('', '');
    let resp = await this.cs.getComplaints(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.tspinner.hide();
      this.allComplaints = resp.data.map((complaint: any) => {
        try {
          const deptArray = JSON.parse(complaint.dept || '[]');
          complaint.departments = deptArray.map((item: any) => Object.values(item));
          complaint.deptName = complaint.departments.map((d: any) => Array.isArray(d) ? d.join(' ') : d.toString()).join(', ');
        } catch (err) {
          complaint.departments = [];
          complaint.deptName = complaint.dept || '';
        }
        return complaint;
      });
      const zones = new Set<string>();
      const depts = new Set<string>();
      this.allComplaints.forEach((item: any) => {
        if (item.zone) zones.add(item.zone);
        if (item.deptName) depts.add(item.deptName);
      });
      this.uniqueZones = Array.from(zones).sort();
      this.uniqueDepartments = Array.from(depts).sort();
      this.applyFilters();
    } else {
      this.tspinner.hide();
      Swal.fire('Opps !!', resp['data'], 'error');
    }
  }

  applyFilters(): void {
    const searchValue = this.searchText.trim().toLowerCase();
    const zoneValue = this.selectedZone ? this.selectedZone.toLowerCase() : '';
    const deptValue = this.selectedDept ? this.selectedDept.toLowerCase() : '';

    let fromDateValue: Date | null = null;
    let toDateValue: Date | null = null;

    if (this.fromDate && !this.toDate) {
      fromDateValue = new Date(this.fromDate);
      fromDateValue.setHours(0, 0, 0, 0);
      toDateValue = new Date(this.fromDate);
      toDateValue.setHours(23, 59, 59, 999);
    } else if (!this.fromDate && this.toDate) {
      fromDateValue = new Date(this.toDate);
      fromDateValue.setHours(0, 0, 0, 0);
      toDateValue = new Date(this.toDate);
      toDateValue.setHours(23, 59, 59, 999);
    } else if (this.fromDate && this.toDate) {
      fromDateValue = new Date(this.fromDate);
      fromDateValue.setHours(0, 0, 0, 0);
      toDateValue = new Date(this.toDate);
      toDateValue.setHours(23, 59, 59, 999);
    }

    const filtered = this.allComplaints.filter((item: any) => {
      const ticketId = item.ticket_id ? item.ticket_id.toString().toLowerCase() : '';
      const zone = item.zone ? item.zone.toLowerCase() : '';
      const fullName = item.full_name ? item.full_name.toLowerCase() : '';
      const mobileNo = item.mobile_no ? item.mobile_no.toString().toLowerCase() : '';
      const deptStr = item.deptName ? item.deptName.toLowerCase() : '';
      const status = item.status ? item.status.toLowerCase() : '';
      const createDate = item.create_date ? item.create_date.toLowerCase() : '';

      const matchesSearch = !searchValue ||
        ticketId.includes(searchValue) ||
        zone.includes(searchValue) ||
        fullName.includes(searchValue) ||
        mobileNo.includes(searchValue) ||
        deptStr.includes(searchValue) ||
        createDate.includes(searchValue) ||
        status.includes(searchValue);

      const matchesZone = !zoneValue || zone === zoneValue;
      const matchesDept = !deptValue || deptStr.includes(deptValue);

      let matchesDate = true;
      if (fromDateValue || toDateValue) {
        if (item.create_date) {
            let createDateVal: Date | null = null;
            const dateStr = item.create_date.split(' ')[0];
            const parts = dateStr.split(/[-/]/);
            if (parts.length === 3) {
              if (parts[0].length === 4) {
                 createDateVal = new Date(item.create_date);
              } else {
                 createDateVal = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
                 if (isNaN(createDateVal.getTime())) {
                    createDateVal = new Date(item.create_date);
                 }
              }
            } else {
              createDateVal = new Date(item.create_date);
            }
            
            if (createDateVal && !isNaN(createDateVal.getTime())) {
                if (fromDateValue && createDateVal < fromDateValue) matchesDate = false;
                if (toDateValue && createDateVal > toDateValue) matchesDate = false;
            }
        } else {
            matchesDate = false;
        }
      }
      return matchesSearch && matchesZone && matchesDept && matchesDate;
    });

    this.complaints.data = filtered;
    if (this.paginator) {
      this.paginator.firstPage();
    }
    this.complaints.paginator = this.paginator;
  }

  clearFilters(): void {
    this.searchText = '';
    this.fromDate = null;
    this.toDate = null;
    this.selectedZone = null;
    this.selectedDept = null;
    this.applyFilters();
  }

  route(element: any) {
    this.router.navigate(['sdp/complaints/preview'], { state: { data: element } });
  }

  exportToExcel() {
    const dataToExport = this.complaints.data.map((item: any, index: number) => {
      const row: any = {};
      row[this.translation.t('export', 'srNo')] = index + 1;
      row[this.translation.t('export', 'ticketId')] = item.ticket_id;
      row[this.translation.t('export', 'department')] = this.pdfService.extractEnglishDepartments(item.dept);
      row[this.translation.t('export', 'zone')] = item.zone;
      row[this.translation.t('export', 'fullName')] = item.full_name;
      row[this.translation.t('export', 'mobileNo')] = item.mobile_no;
      row[this.translation.t('export', 'complaintDate')] = item.create_date;
      return row;
    });
    this.excelService.exportAsExcelFile(dataToExport, 'Closed_Complaints');
  }

  exportToPDF() {
    const headers = [
      this.translation.t('export', 'srNo'),
      this.translation.t('export', 'ticketId'),
      this.translation.t('export', 'department'),
      this.translation.t('export', 'zone'),
      this.translation.t('export', 'fullName'),
      this.translation.t('export', 'mobileNo'),
      this.translation.t('export', 'complaintDate')
    ];
    this.pdfService.generateTablePDF(this.complaints.data, 'Closed Complaints Report', headers);
  }
}
